<template>
 <div class="table-responsive">
    <!-- Table Search -->
          <div class="input-group col-md-2 tab-sch tbl-sch rounded">
              <input v-on:keyup.enter="searchOffer" @keypress="isAlphanumeric($event)" type="text" v-model.trim="searchValue" class="form-control rounded" placeholder="Search" />
              <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
              <span @click="searchOffer()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>

          </div>
        <!-- Table Search -->
        <table class="table align-items-center table-flush table-hover bidtbl">
            <thead class="thead-light psticky">
            <tr >
              <th 
                scope="col" 
                class="sort"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                @click="sort('cusip')">CUSIP</th>
              <th 
                scope="col" 
                class="sort"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'account'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'account'  ? 'sort-desc' : '']"  
                @click="sort('account')">ACCOUNT</th>
                <th 
                scope="col" 
                class="sort"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'customerName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'customerName'  ? 'sort-desc' : '']"  
                @click="sort('customerName')">CUSTOMER</th>
                <th 
                scope="col" 
                class="sort text-center"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bondType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bondType'  ? 'sort-desc' : '']"  
                @click="sort('bondType')">BOND TYPE</th>
                <th
                  scope="col"
                  class="sort text-center"
                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'boughtDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'boughtDate'  ? 'sort-desc' : '']"  
                  @click="sort('boughtDate')">BOUGHT DATE
                  </th>
                <th 
                scope="col" 
                class="sort text-center"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'broker'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'broker'  ? 'sort-desc' : '']"  
                @click="sort('broker')">BROKER</th>
                <th 
                scope="col" 
                class="sort text-center"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                @click="sort('cost')">COST</th>
                <th 
                scope="col" 
                class="sort text-center"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                @click="sort('price')">PRICE</th>
                <th 
                scope="col" 
                class="sort text-center"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                @click="sort('quantity')">QUANTITY</th>
                <th 
                scope="col" 
                class="sort text-center"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'spread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'spread'  ? 'sort-desc' : '']"  
                @click="sort('spread')">SPREAD</th>
                <th 
                scope="col" 
                class="sort text-center"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offeringType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offeringType'  ? 'sort-desc' : '']"  
                @click="sort('offeringType')">OFFER TYPE</th>
                <th 
                scope="col" 
                class="sort text-center"
                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                @click="sort('yield')">YIELD</th>
                  
            </tr>
            </thead>
            <tbody class="list">
            <tr v-if="totalRows == 0 && !loading">
                <td><p class="nodata">No data available</p>
                </td>
            </tr>
            <tr v-for="offer in offerings" :key="offer.id" @click="getOfferDetails(offer)" v-bind:class="{'active-row': offer.isActive}">
                <td>
                  <span v-if="offer.errorType == 'MISSING'" style="color:red">
                    <i data-toggle="tooltip" v-bind:title="cusipWarningMessage" class="fas fa-exclamation-triangle" style="cursor:pointer;font-size:12px;color:red"></i>
                    {{offer.cusip}}</span>
                  <span v-if="offer.errorType != 'MISSING'">{{offer.cusip ? offer.cusip : 'N/A' }}</span>
                </td>
                <td class="text-center">
                  <span v-if="offer.errorType == 'NOACCOUNTMAP'" style="color:red">
                    <i data-toggle="tooltip" v-bind:title="invNoAccountWarningMessage" class="fas fa-exclamation-triangle" style="cursor:pointer;font-size:12px;color:red"></i>
                    {{offer.account}}</span>
                  <span v-if="offer.errorType != 'NOACCOUNTMAP'">{{offer.account}}</span>
                </td>
                  <td class="text-center">
                    <span>{{offer.customerName}}</span><br>
                </td>
                <td class="text-center">
                    <span>{{offer.bondType}}</span><br>
                </td>
                <td class="text-center">
                    <span>{{moment(offer.boughtDate).format("MM/DD/YYYY") }}</span><br>
                </td>
                <td class="text-center">
                    <span>{{offer.broker}}</span><br>
                </td>
                <td class="text-center">
                    <span>{{offer.cost | currency}}</span><br>
                </td>
                <td class="text-center">
                    <span>{{offer.price | currency }}   </span><br>
                </td>
                <td class="text-center">
                    <span>{{offer.quantity}}</span><br>
                </td>
                <td class="text-center">
                    <span>{{offer.spread ? offer.spread.toFixed(2) : 0}}</span><br>
                </td>
                <td class="text-center">
                    <span>{{offer.offeringType}}</span><br>
                </td>
                <td class="text-center">
                    <span>{{offer.yield}}</span><br>
                </td>
              </tr>
            </tbody>
            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

        </table>
        <!-- Pagination-->
        <b-pagination
            class="mt-4"
            :total-rows="totalRows"
            v-model="currentPage"
            :per-page="perPage"
            @input="getOfferList(currentPage)"
        ></b-pagination>
        <div class="total-records">
            <span>Total Records : {{totalRows}}</span>
        </div>
</div>    
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
export default {
  name: "imsErrorOfferingComponent",
  components : {
    
  },
  data() {
    return {
        accessToken: null,
        config: config,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        selectedCusip : "",
        sortColumn: "account",
        sortOrder: "ASC",
        stateConstants: stateConstants,
        offerings:[],
        invNoAccountWarningMessage : "PLEASE ADD THIS ACCOUNT TO CUSTOMER TO RESOLVE",
        cusipWarningMessage : "CUSIP ID MISSING"

    };
  },
  methods: {
     getEcnStatus(ecnStatus){
      // if(ecnStatus == 'NEW'){
      //   return  { className : "border-success text-success",status : "NEW" }
      // }
      // if(ecnStatus == 'CREATED'){
      //   return  { className : "border-success text-success",status : "CREATED" }
      // }
      // if(ecnStatus == 'SUCCESS'){
      //   return  { className : "border-success text-success",status : "ACCEPTED" }
      // }
      if(!ecnStatus) ecnStatus = 'N/A'
      return  { className : "border-success text-success",status : ecnStatus }
    },
    searchOffer(){
      this.getOfferList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getOfferList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getOfferList();
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getOfferDetails(offerSelected){
      this.offer.forEach(function(offer) {
        offer.isActive = false;
      });
      offerSelected.isActive = true;
    },
    getOfferList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/offer/waiting-offer?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder,
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
        //   result.data.content.forEach(function(cusip) {
        //    cusip.isActive = false;
        //   });
           this.offerings = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
  },
  mounted() {
      this.getOfferList();

  }
};
</script>